import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/core';

@Component({
  selector: 'app-generic-table-header-renderer',
  templateUrl: './generic-table-header-renderer.component.html',
  styleUrls: ['./generic-table-header-renderer.component.less'],
})
export class GenericTableHeaderRendererComponent implements OnInit {
  @Input() data: any;

  config = [
    {
      label: 'COMMON.TABLE.NAME',
      sortBy: 'NAME',
      filterEnable: true,
    },
  ];

  constructor(private translate: TranslationService) {}

  ngOnInit(): void {}
}
